import { Form, ReformSubmitHandler, Submit, Textarea } from '@kodkafa/reform';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProfile } from '@/hooks';
import {
  useClanControllerFindOneQuery,
  useClanControllerUpdateMutation,
} from '@/store/services/MidleNestApi.service';

export default function ChangeMessage() {
  const { t } = useTranslation();
  const { profile } = useProfile();

  const { data: clan } = useClanControllerFindOneQuery(profile?.clan?.id || '', {
    skip: !profile?.clan,
  });

  const [update] = useClanControllerUpdateMutation();

  const onSubmit = React.useCallback<ReformSubmitHandler<{ message?: string }>>(
    async (data, setError) => {
      if (!data.message) return;

      const result = await update({
        id: clan?.id || '',
        updateClanDto: { message: data.message },
      }).unwrap();
    },
    [update],
  );

  return (
    <div className='flex flex-col gap-y-8'>
      <h3 className='text-xl leading-7 font-medium'>{t('Clan Message')}</h3>
      <div className='overflow-y-auto max-h-none sm:max-h-[530px] px-2 py-2'>
        <Form onSubmit={onSubmit}>
          <Textarea
            // label={t('Clan Message')}
            name='message'
            className='font-light'
            style={{ height: 160 }}
            placeholder='message'
            defaultValue={clan?.message}
          />
          <div className='flex w-full justify-end mt-2'>
            <Submit className='py-2'>{t('Save')}</Submit>
          </div>
        </Form>
      </div>
    </div>
  );
}
